/* Presentation details for the Shopify product page; purchase state stays in the theme. */
(() => {
  function initialize(root) {
    if (root.dataset.dcProductParityReady) return;

    const price = root.querySelector('.product__price');
    const frameBlock = root.querySelector('[data-frame-upsell]');
    const addButtonText = root.querySelector('[data-add-to-cart-text]');
    if (!price || !frameBlock || !addButtonText) return;
    root.dataset.dcProductParityReady = 'true';

    // The print's legacy "no frame" variant must stay selected for the
    // separate frame-product tiles. Hide its redundant control only in that
    // state; a direct link to an older framed variant keeps the control visible.
    const legacyFrameSelector = [...root.querySelectorAll('.product__selectors .selector-wrapper')]
      .find(wrapper => /^(ram|frame|marco)$/i.test(wrapper.querySelector('.radio__legend__option-name')?.textContent.trim() || ''));
    if (legacyFrameSelector) {
      const legacyValue = legacyFrameSelector.querySelector('[data-option-value]');
      const updateLegacyFrameSelector = () => {
        const value = legacyValue?.textContent.trim().toLowerCase() || '';
        legacyFrameSelector.hidden = /^(utan ram|no frame|without frame|sin marco)$/.test(value);
      };
      if (legacyValue) new MutationObserver(updateLegacyFrameSelector).observe(legacyValue, { childList: true, characterData: true, subtree: true });
      updateLegacyFrameSelector();
    }

    // The sticky purchase column is a positioned ancestor. Keep the trail on
    // the section and anchor the sale label to the main image, not the thumbs.
    const trail = root.querySelector('.dc-product-trail');
    const saleTag = root.querySelector('[data-dc-sale-tag]');
    if (trail) root.prepend(trail);
    const mediaRoot = root.querySelector('product-images');
    if (saleTag && mediaRoot) mediaRoot.append(saleTag);

    // Keep Shopify's real media IDs and gallery controls while showing the
    // approved room photographs from the local product study.
    const roomConfig = document.getElementById('dc-product-room-images');
    if (roomConfig) {
      try {
        const rooms = JSON.parse(roomConfig.textContent).rooms;
        const media = root.querySelector('product-images');
        const slideList = media?.querySelector('[data-product-media-list]');
        const zoomGallery = slideList?.matches('zoom-images') ? slideList : null;
        const thumbsElement = media?.querySelector('product-thumbs');
        const thumbList = thumbsElement?.querySelector('[data-thumbs-slider]');
        const slides = [...root.querySelectorAll('.product__slide[data-type="image"]')];
        const thumbs = [...root.querySelectorAll('.product__thumb__link')];
        const originalSlideCount = slides.length;
        rooms.forEach((room, index) => {
          // Product media is merchant-owned. Add editorial rooms after every
          // original image instead of replacing the second and third images.
          let slide;
          let thumb;
          if (slideList && thumbList && slides[0] && thumbs[0]) {
            const mediaId = `${root.dataset.sectionId}-dc-room-${index + 1}`;
            slide = slides[0].cloneNode(true);
            slide.classList.remove('media--active');
            slide.classList.add('media--hidden');
            slide.setAttribute('data-image-id', `dc-room-${index + 1}`);
            slide.setAttribute('data-media-id', mediaId);
            slide.querySelector('[data-frame-overlay]')?.remove();
            // The theme keeps its navigation buttons as the last child of the
            // media list. Keep every added slide before those buttons so the
            // carousel's next-slide lookup reaches the editorial rooms.
            const arrows = slideList.querySelector('.slider__arrows');
            slideList.insertBefore(slide, arrows?.parentElement === slideList ? arrows : null);
            const thumbItem = thumbs[0].closest('[data-thumb-item]').cloneNode(true);
            thumb = thumbItem.querySelector('.product__thumb__link');
            thumb.setAttribute('data-media-id', mediaId);
            thumb.setAttribute('aria-current', 'false');
            thumbItem.classList.remove('is-active');
            thumbList.append(thumbItem);
            thumb.addEventListener('click', event => {
              event.preventDefault();
              media.dispatchEvent(new CustomEvent('theme:media:select', { detail: { id: mediaId } }));
            });
            slides.push(slide);
            thumbs.push(thumb);
          }
          if (!slide || !thumb) return;
          const photo = slide.querySelector('.product__photo');
          const image = slide.querySelector('.product__photo img:not(.product__frame-overlay)');
          const thumbImage = thumb.querySelector('img');
          for (const element of [image, thumbImage]) {
            if (!element) continue;
            element.removeAttribute('srcset');
            element.removeAttribute('sizes');
            element.removeAttribute('data-src');
            element.removeAttribute('data-srcset');
            element.src = room.url;
            element.alt = room.alt;
          }
          photo?.setAttribute('data-image-src', room.url);
          photo?.setAttribute('data-image-width', '1024');
          photo?.setAttribute('data-image-height', '1536');
          thumb.href = room.url;
        });
        if (zoomGallery) {
          // zoom.js captures the media list when the custom element connects.
          // Include room slides added later and bind zoom for the cloned ones.
          zoomGallery.images = zoomGallery.querySelectorAll('[data-zoom-image]');
          zoomGallery.images.forEach((photo, index) => {
            if (index < originalSlideCount) return;
            photo.addEventListener('click', event => {
              event.preventDefault();
              zoomGallery.createZoom(index);
              window.accessibility.lastElement = photo;
            });
            photo.addEventListener('keyup', event => {
              if (event.code !== 'Enter') return;
              event.preventDefault();
              zoomGallery.createZoom(index);
              window.accessibility.lastElement = photo;
            });
          });
          const zoomThumbs = media.querySelector('[data-pswp-thumbs-template]');
          if (zoomThumbs) {
            zoomThumbs.innerHTML = [...zoomGallery.images].map(photo => {
              const image = photo.querySelector('img:not(.product__frame-overlay)');
              const src = photo.getAttribute('data-image-src');
              const thumb = document.createElement('img');
              thumb.className = 'pswp__thumb';
              thumb.src = src;
              thumb.alt = image?.alt || '';
              return thumb.outerHTML;
            }).join('');
          }
        }
        if (media && slides.length > originalSlideCount) {
          media.productMediaItems = media.querySelectorAll('.product__slide[data-image-id]');
          if (originalSlideCount === 1) media.connectedCallback();
          else media.productMediaObserver();
        }
      } catch (error) {
        console.warn('Product room gallery could not be loaded', error);
      }
    }

    const media = root.querySelector('product-images');
    const mediaSlides = [...root.querySelectorAll('.product__slide[data-type="image"]')];
    const thumbsHolder = media?.querySelector('.product__thumbs');
    if (media && thumbsHolder && mediaSlides.length) {
      const caption = document.createElement('div');
      caption.className = 'dc-product-media-caption';
      caption.innerHTML = '<span></span><span data-dc-media-count></span>';
      caption.firstElementChild.textContent = document.querySelector('h1.product__title')?.textContent.trim() || '';
      const slidesContainer = media.querySelector('.product__slides');
      if (slidesContainer) slidesContainer.append(caption);
      const updateCaption = () => {
        const activeId = media.getAttribute('data-active-media');
        const activeIndex = mediaSlides.findIndex(slide => slide.getAttribute('data-media-id') === activeId);
        caption.querySelector('[data-dc-media-count]').textContent = `${String(Math.max(activeIndex, 0) + 1).padStart(2, '0')} / ${String(mediaSlides.length).padStart(2, '0')}`;
      };
      new MutationObserver(updateCaption).observe(media, { attributes: true, attributeFilter: ['data-active-media'] });
      updateCaption();
    }

    const ellipsis = root.querySelector('.product__description toggle-ellipsis');
    if (ellipsis) {
      const content = ellipsis.querySelector('[data-content]');
      if (content) {
        ellipsis.classList.toggle('dc-no-ellipsis', content.textContent.trim().length <= 160);
      }
    }

    const language = document.documentElement.lang.slice(0, 2);
    const labels = {
      en: { print: 'print only', total: 'Total', off: 'OFF', less: 'Read less' },
      sv: { print: 'utan ram', total: 'Totalt', off: 'RABATT', less: 'Läs mindre' },
      es: { print: 'sin marco', total: 'Total', off: 'DTO.', less: 'Leer menos' }
    }[language] || { print: 'print only', total: 'Total', off: 'OFF', less: 'Read less' };

    const discount = document.createElement('span');
    discount.className = 'dc-product-discount';
    price.append(discount);

    const configuration = document.createElement('div');
    configuration.className = 'dc-product-configuration';
    const configurationLabel = document.createElement('span');
    configuration.append(configurationLabel);
    const savingsBadge = price.querySelector('[data-save-badge]');
    if (savingsBadge) configuration.append(savingsBadge);
    price.closest('.product__price__wrap').after(configuration);

    const summary = document.createElement('div');
    summary.className = 'dc-product-summary';
    summary.innerHTML = `<span>${labels.total}</span><strong data-dc-product-total></strong>`;
    frameBlock.after(summary);

    function refresh() {
      const tag = root.querySelector('[data-dc-sale-tag]');
      const percent = tag?.querySelector('[data-dc-sale-percent]')?.textContent.trim();
      discount.textContent = percent && !tag.hidden ? `${percent}% ${labels.off}` : '';
      discount.hidden = !discount.textContent;

      const chosenSize = root.querySelector('.size-tile--active .size-tile__name')?.textContent.trim()
        || root.querySelector('.size-tiles input:checked')?.value
        || '';
      const chosenFrame = root.querySelector('.frame-tile--active .frame-tile__name')?.textContent.trim();
      configurationLabel.textContent = `${chosenSize} · ${chosenFrame || labels.print}`;

      const buttonLabel = addButtonText.textContent.trim();
      const amount = buttonLabel.split('—').pop()?.trim();
      summary.querySelector('[data-dc-product-total]').textContent = amount && amount !== buttonLabel
        ? amount
        : root.querySelector('[data-product-price]')?.textContent.trim() || '';
    }

    document.addEventListener('theme:variant:change', event => {
      if (!root.contains(event.target)) return;
      const variant = event.detail?.variant;
      const tag = root.querySelector('[data-dc-sale-tag]');
      if (tag && variant) {
        const comparison = Number(variant.compare_at_price);
        const current = Number(variant.price);
        const percent = comparison > current ? Math.round((comparison - current) * 100 / comparison) : 0;
        tag.hidden = !percent;
        tag.querySelector('[data-dc-sale-percent]').textContent = String(percent);
      }
      requestAnimationFrame(refresh);
    });

    root.addEventListener('change', event => {
      if (event.target.closest('.size-tiles')) requestAnimationFrame(refresh);
    });
    frameBlock.addEventListener('click', () => requestAnimationFrame(refresh));

    // Start at the most popular 50x70 size. Preserve a variant supplied in
    // the incoming URL, including links from collections and saved carts.
    if (window.dcProductHadVariantOnEntry === false) {
      const chooseDefault50x70 = () => {
        const popularTile = root.querySelector('.size-tile--popular');
        const popularInput = popularTile?.querySelector('input[type="radio"]');
        if (popularInput && !popularInput.disabled && !popularInput.checked) {
          popularInput.checked = true;
          popularInput.dispatchEvent(new Event('change', { bubbles: true }));
          requestAnimationFrame(refresh);
        }
      };
      if (document.readyState === 'complete') chooseDefault50x70();
      else document.addEventListener('DOMContentLoaded', chooseDefault50x70, { once: true });
    }

    const sizeGuideTrigger = root.querySelector('.size-tiles__heading [data-popup-open]');
    if (sizeGuideTrigger) {
      const guideText = {
        en: {
          open: 'Size guide', eyebrow: 'A little perspective', title: 'Find your size.',
          intro: 'See how our print sizes compare, then picture them on your wall.',
          scale: 'Proportional print sizes', close: 'Close size guide',
          uses: ['For a shelf or a grouped wall.', 'For a small space or paired works.', 'A versatile, substantial single print.', 'For a bold statement on a larger wall.'],
          note: 'Measurements refer to the print. A frame adds a little to the outer size. Mark the dimensions on your wall with tape before choosing.'
        },
        sv: {
          open: 'Storleksguide', eyebrow: 'Lite perspektiv', title: 'Hitta din storlek.',
          intro: 'Jämför storlekarna och föreställ dig dem på din vägg.',
          scale: 'Storlekar i proportion', close: 'Stäng storleksguiden',
          uses: ['För en hylla eller tavelvägg.', 'För ett mindre utrymme eller två verk tillsammans.', 'Ett mångsidigt format som fungerar på egen hand.', 'För ett tydligt blickfång på en större vägg.'],
          note: 'Måtten avser konstverket. En ram gör yttermåttet något större. Markera gärna måtten på väggen med tejp innan du väljer.'
        },
        es: {
          open: 'Guía de tamaños', eyebrow: 'Un poco de perspectiva', title: 'Encuentra tu tamaño.',
          intro: 'Compara los tamaños e imagínalos en tu pared.',
          scale: 'Tamaños a escala', close: 'Cerrar la guía de tamaños',
          uses: ['Para una repisa o una pared de cuadros.', 'Para un espacio pequeño o dos obras juntas.', 'Un formato versátil que destaca por sí solo.', 'Para una pared amplia y un efecto protagonista.'],
          note: 'Las medidas corresponden a la lámina. El marco aumenta ligeramente el tamaño exterior. Marca las dimensiones en la pared con cinta antes de elegir.'
        }
      }[language] || null;
      const guide = guideText || {
        open: 'Size guide', eyebrow: 'A little perspective', title: 'Find your size.',
        intro: 'See how our print sizes compare, then picture them on your wall.',
        scale: 'Proportional print sizes', close: 'Close size guide',
        uses: ['For a shelf or a grouped wall.', 'For a small space or paired works.', 'A versatile, substantial single print.', 'For a bold statement on a larger wall.'],
        note: 'Measurements refer to the print. A frame adds a little to the outer size. Mark the dimensions on your wall with tape before choosing.'
      };
      const sizeDialog = document.createElement('dialog');
      sizeDialog.className = 'dc-size-guide';
      sizeDialog.setAttribute('aria-labelledby', 'dc-size-guide-title');
      sizeDialog.innerHTML = '<button type="button" class="dc-size-guide-close" aria-label=""></button>'
        + '<div class="dc-size-guide-art"><span class="dc-size-guide-scale-label"></span>'
        + '<div class="dc-size-guide-scale" role="img"><span></span><span></span><span></span><span></span></div></div>'
        + '<div class="dc-size-guide-copy"><span class="dc-size-guide-eyebrow"></span>'
        + '<h2 id="dc-size-guide-title"></h2><p class="dc-size-guide-intro"></p>'
        + '<ul class="dc-size-guide-list"></ul><p class="dc-size-guide-note"></p></div>';
      sizeDialog.querySelector('.dc-size-guide-close').setAttribute('aria-label', guide.close);
      sizeDialog.querySelector('.dc-size-guide-scale-label').textContent = guide.scale;
      sizeDialog.querySelector('.dc-size-guide-scale').setAttribute('aria-label', guide.scale);
      sizeDialog.querySelector('.dc-size-guide-eyebrow').textContent = guide.eyebrow;
      sizeDialog.querySelector('h2').textContent = guide.title;
      sizeDialog.querySelector('.dc-size-guide-intro').textContent = guide.intro;
      sizeDialog.querySelector('.dc-size-guide-note').textContent = guide.note;
      const measurements = ['21 × 29.7 cm · 8.3 × 11.7 in', '30 × 40 cm · 11.8 × 15.7 in',
        '50 × 70 cm · 19.7 × 27.6 in', '70 × 100 cm · 27.6 × 39.4 in'];
      ['A4', '30 × 40', '50 × 70', '70 × 100'].forEach((name, index) => {
        const item = document.createElement('li');
        const strong = document.createElement('strong');
        const detail = document.createElement('span');
        strong.textContent = name;
        detail.append(document.createTextNode(measurements[index]), document.createElement('br'),
          document.createTextNode(guide.uses[index]));
        item.append(strong, detail);
        sizeDialog.querySelector('.dc-size-guide-list').append(item);
      });
      root.append(sizeDialog);
      sizeGuideTrigger.textContent = guide.open;
      sizeGuideTrigger.setAttribute('aria-haspopup', 'dialog');
      sizeGuideTrigger.addEventListener('click', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        sizeDialog.showModal();
      }, true);
      sizeDialog.querySelector('.dc-size-guide-close').addEventListener('click', () => sizeDialog.close());
      sizeDialog.addEventListener('click', event => {
        if (event.target === sizeDialog) sizeDialog.close();
      });
      sizeDialog.addEventListener('close', () => sizeGuideTrigger.focus());
    }

    const frameGuide = frameBlock.querySelector('[data-dc-frame-guide]');
    const frameGuideOpen = frameBlock.querySelector('[data-dc-frame-guide-open]');
    if (frameGuide && frameGuideOpen) {
      frameGuideOpen.addEventListener('click', () => frameGuide.showModal());
      frameGuide.querySelector('[data-dc-frame-guide-close]')?.addEventListener('click', () => frameGuide.close());
      frameGuide.addEventListener('click', event => {
        if (event.target === frameGuide) frameGuide.close();
      });
      frameGuide.addEventListener('close', () => frameGuideOpen.focus());
    }
    root.addEventListener('click', event => {
      const trigger = event.target.closest('toggle-ellipsis [data-button]');
      if (!trigger) return;
      const ellipsis = trigger.closest('toggle-ellipsis');
      const label = trigger.querySelector('span');
      if (!ellipsis || !label) return;
      const more = trigger.dataset.dcMoreLabel || label.textContent;
      trigger.dataset.dcMoreLabel = more;
      if (ellipsis.classList.contains('is-open')) {
        event.preventDefault();
        event.stopPropagation();
        ellipsis.classList.remove('is-open');
        ellipsis.style.setProperty('--height', `${ellipsis.dataset.height}px`);
        label.textContent = more;
      } else {
        requestAnimationFrame(() => { label.textContent = labels.less; });
      }
    }, true);

    const addButton = root.querySelector('[data-add-to-cart]');
    if (addButton) {
      const sticky = document.createElement('button');
      sticky.className = 'dc-product-mobile-buy';
      sticky.type = 'button';
      sticky.textContent = addButtonText.textContent.trim();
      sticky.addEventListener('click', () => addButton.click());
      document.body.append(sticky);
      const updateSticky = () => {
        sticky.textContent = addButtonText.textContent.trim();
        sticky.disabled = addButton.disabled;
      };
      new MutationObserver(updateSticky).observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
      new MutationObserver(updateSticky).observe(addButtonText, { childList: true, characterData: true, subtree: true });
      sticky.setAttribute('aria-label', addButtonText.textContent.trim());
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      }).observe(addButton);
    }
    new MutationObserver(refresh).observe(addButtonText, { childList: true, characterData: true, subtree: true });
    refresh();
  }

  function start() {
    document.querySelectorAll('body.template-product .index-product').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
